import Vue from 'vue'
import Vuex from 'vuex'
import space from './modules/space'
import mapFunctions from './modules/mapFunctions'
import ui from './modules/ui'

Vue.use(Vuex)

export default new Vuex.Store({
  modules:  { space, mapFunctions, ui	}
})
